export enum PresentationMenuType {
  GROUP = 'menuGroup',
  PRESENTATION = 'menuPresentation',
}
